import React, { useEffect } from 'react';
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { auth0Config } from "../../auth0Config";
import { setAuth0Client } from "../../util/axiosInstance";

/**
 * Inner component to access Auth0 client and set it for axios interceptor
 */
const Auth0ClientSetter = ({ children }) => {
  const auth0 = useAuth0();

  useEffect(() => {
    if (!auth0.isLoading) {
      setAuth0Client(auth0);
    }
  }, [auth0, auth0.isLoading]);

  return children;
};

/**
 * Authentication Provider Wrapper
 * Now using Auth0 exclusively
 */
const AuthProvider = ({ children }) => {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      cacheLocation={auth0Config.cacheLocation}
      useRefreshTokens={auth0Config.useRefreshTokens}
      useRefreshTokensFallback={auth0Config.useRefreshTokensFallback}
      onRedirectCallback={(appState, user) => {
        // Navigate to the page the user was trying to access before login
        window.history.replaceState(
          {},
          document.title,
          appState?.returnTo || window.location.pathname
        );
      }}
    >
      <Auth0ClientSetter>
        {children}
      </Auth0ClientSetter>
    </Auth0Provider>
  );
};

export default AuthProvider;